export default __webpack_public_path__ + "static/2-ae46cb9a2953dc8bf586ef898d03adf4.jpeg";